import "./ChromeTitle.css";

// Section title in the logo's lettering: capitals at full size, the other
// letters as capitals at 83% (the ratio in logo.png), in chrome. The text
// stays in normal case in the page, so screen readers read it as words.
const ChromeTitle = ({ text }) => (
  <span className="chrome-text">
    {text.split(/([a-z]+)/).map((part, i) =>
      i % 2 ? (
        <span key={i} className="chrome-text__small">
          {part}
        </span>
      ) : (
        part
      ),
    )}
  </span>
);

export default ChromeTitle;
